function isTouchEvent(evt) {
  return "touches" in evt && evt.touches.length > 0;
}

export { isTouchEvent };
//# sourceMappingURL=isTouchEvent.js.map
